import styled from 'styled-components';

const getSurfaceBg = (props) => (props.theme && props.theme.colors && props.theme.colors.surface && props.theme.colors.surface.background) || '#f0f4f8';
const getBrandPrimary = (props) => (props.theme && props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) || '#004085';

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const TooltipContent = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 8px;
  background-color: ${props => getSurfaceBg(props)};
  color: ${props => getBrandPrimary(props)};
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  white-space: nowrap;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
  transition: opacity 0.2s, visibility 0.2s;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: ${props => getSurfaceBg(props)} transparent transparent transparent;
  }
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Tooltip/components/TooltipStyles.js